// removed by extract-text-webpack-plugin
module.exports = {"textBlock":"cover-text-input---textBlock---2dUWy","row":"cover-text-input---row---P2yOB","alignTextDiv":"cover-text-input---alignTextDiv---34neJ","alignTextItem":"cover-text-input---alignTextItem---Y0gEQ","removeTextButton":"cover-text-input---removeTextButton---Kzej-","inputField":"cover-text-input---inputField---3bs4E","col33":"cover-text-input---col33---2V3EZ","col66":"cover-text-input---col66---3Z5i_","rotateTextButton":"cover-text-input---rotateTextButton---3oE9F","rotateTextButtonActive":"cover-text-input---rotateTextButtonActive---1v66P","alignTextItemSelected":"cover-text-input---alignTextItemSelected---1fIjY","alignTextItemDisabled":"cover-text-input---alignTextItemDisabled---2qDoW","alignTextItemSmall":"cover-text-input---alignTextItemSmall---C377k","alignTextItemImageAuto":"cover-text-input---alignTextItemImageAuto---3FUbq","iconPickerIcon":"cover-text-input---iconPickerIcon---1BH9n"};;
    if (module.hot) {
      var injectCss = function injectCss(prev, href) {
        var link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = href;
        link.onload = function() {
          document.head.removeChild(prev);
        };
        document.head.appendChild(link);
      };
      module.hot.dispose(function() {
        window.__webpack_reload_css__ = true;
      });
      if (window.__webpack_reload_css__) {
        module.hot.__webpack_reload_css__ = false;
        console.log("[HMR] Reloading stylesheets...");
        var prefix = document.location.protocol + '//' + document.location.host;
        document
          .querySelectorAll("link[href][rel=stylesheet]")
          .forEach(function(link) {
            if (!link.href.match(prefix)) return;
            injectCss(link, link.href.split("?")[0] + "?unix=1789047462345");
          });
      }
    }
  